export default __webpack_public_path__ + "static/media/voucherGTS4.38c16a66.jpg";